export const COUNTRIES = {
  US: {
    code: "US",
    name: "United States",
    phoneCode: "+1",
    phoneFormat: "US",
    stateLabel: "State",
    postalCodeLabel: "ZIP Code",
    postalCodePattern: "\\d{5}(-\\d{4})?",
    postalCodePlaceholder: "12345",
    postalCodeMaxLength: 5,
    states: [
      { code: "AL", name: "Alabama" },
      { code: "AK", name: "Alaska" },
      { code: "AZ", name: "Arizona" },
      { code: "AR", name: "Arkansas" },
      { code: "CA", name: "California" },
      { code: "CO", name: "Colorado" },
      { code: "CT", name: "Connecticut" },
      { code: "DE", name: "Delaware" },
      { code: "DC", name: "District of Columbia" },
      { code: "FL", name: "Florida" },
      { code: "GA", name: "Georgia" },
      { code: "HI", name: "Hawaii" },
      { code: "ID", name: "Idaho" },
      { code: "IL", name: "Illinois" },
      { code: "IN", name: "Indiana" },
      { code: "IA", name: "Iowa" },
      { code: "KS", name: "Kansas" },
      { code: "KY", name: "Kentucky" },
      { code: "LA", name: "Louisiana" },
      { code: "ME", name: "Maine" },
      { code: "MD", name: "Maryland" },
      { code: "MA", name: "Massachusetts" },
      { code: "MI", name: "Michigan" },
      { code: "MN", name: "Minnesota" },
      { code: "MS", name: "Mississippi" },
      { code: "MO", name: "Missouri" },
      { code: "MT", name: "Montana" },
      { code: "NE", name: "Nebraska" },
      { code: "NV", name: "Nevada" },
      { code: "NH", name: "New Hampshire" },
      { code: "NJ", name: "New Jersey" },
      { code: "NM", name: "New Mexico" },
      { code: "NY", name: "New York" },
      { code: "NC", name: "North Carolina" },
      { code: "ND", name: "North Dakota" },
      { code: "OH", name: "Ohio" },
      { code: "OK", name: "Oklahoma" },
      { code: "OR", name: "Oregon" },
      { code: "PA", name: "Pennsylvania" },
      { code: "RI", name: "Rhode Island" },
      { code: "SC", name: "South Carolina" },
      { code: "SD", name: "South Dakota" },
      { code: "TN", name: "Tennessee" },
      { code: "TX", name: "Texas" },
      { code: "UT", name: "Utah" },
      { code: "VT", name: "Vermont" },
      { code: "VA", name: "Virginia" },
      { code: "WA", name: "Washington" },
      { code: "WV", name: "West Virginia" },
      { code: "WI", name: "Wisconsin" },
      { code: "WY", name: "Wyoming" }
    ]
  },
  CA: {
    code: "CA",
    name: "Canada",
    phoneCode: "+1",
    phoneFormat: "US",
    stateLabel: "Province",
    postalCodeLabel: "Postal Code",
    postalCodePattern: "[A-Z]\\d[A-Z] ?\\d[A-Z]\\d",
    postalCodePlaceholder: "K1A 0B1",
    postalCodeMaxLength: 7,
    states: [
      { code: "AB", name: "Alberta" },
      { code: "BC", name: "British Columbia" },
      { code: "MB", name: "Manitoba" },
      { code: "NB", name: "New Brunswick" },
      { code: "NL", name: "Newfoundland and Labrador" },
      { code: "NT", name: "Northwest Territories" },
      { code: "NS", name: "Nova Scotia" },
      { code: "NU", name: "Nunavut" },
      { code: "ON", name: "Ontario" },
      { code: "PE", name: "Prince Edward Island" },
      { code: "QC", name: "Quebec" },
      { code: "SK", name: "Saskatchewan" },
      { code: "YT", name: "Yukon" }
    ]
  },
  GB: {
    code: "GB",
    name: "United Kingdom",
    phoneCode: "+44",
    phoneFormat: "GB",
    stateLabel: "Region",
    postalCodeLabel: "Postcode",
    postalCodePattern: "[A-Z]{1,2}\\d[A-Z\\d]? ?\\d[A-Z]{2}",
    postalCodePlaceholder: "SW1A 2AA",
    postalCodeMaxLength: 8,
    states: [
      { code: "ENG", name: "England" },
      { code: "SCT", name: "Scotland" },
      { code: "WLS", name: "Wales" },
      { code: "NIR", name: "Northern Ireland" }
    ]
  },
  AU: {
    code: "AU",
    name: "Australia",
    phoneCode: "+61",
    phoneFormat: "AU",
    stateLabel: "State/Territory",
    postalCodeLabel: "Postcode",
    postalCodePattern: "\\d{4}",
    postalCodePlaceholder: "2000",
    postalCodeMaxLength: 4,
    states: [
      { code: "ACT", name: "Australian Capital Territory" },
      { code: "NSW", name: "New South Wales" },
      { code: "NT", name: "Northern Territory" },
      { code: "QLD", name: "Queensland" },
      { code: "SA", name: "South Australia" },
      { code: "TAS", name: "Tasmania" },
      { code: "VIC", name: "Victoria" },
      { code: "WA", name: "Western Australia" }
    ]
  },
  MX: {
    code: "MX",
    name: "Mexico",
    phoneCode: "+52",
    phoneFormat: "MX",
    stateLabel: "State",
    postalCodeLabel: "Postal Code",
    postalCodePattern: "\\d{5}",
    postalCodePlaceholder: "01000",
    postalCodeMaxLength: 5,
    states: [
      { code: "AGU", name: "Aguascalientes" },
      { code: "BCN", name: "Baja California" },
      { code: "BCS", name: "Baja California Sur" },
      { code: "CAM", name: "Campeche" },
      { code: "CHP", name: "Chiapas" },
      { code: "CHH", name: "Chihuahua" },
      { code: "CMX", name: "Ciudad de México" },
      { code: "COA", name: "Coahuila" },
      { code: "COL", name: "Colima" },
      { code: "DUR", name: "Durango" },
      { code: "GUA", name: "Guanajuato" },
      { code: "GRO", name: "Guerrero" },
      { code: "HID", name: "Hidalgo" },
      { code: "JAL", name: "Jalisco" },
      { code: "MEX", name: "México" },
      { code: "MIC", name: "Michoacán" },
      { code: "MOR", name: "Morelos" },
      { code: "NAY", name: "Nayarit" },
      { code: "NLE", name: "Nuevo León" },
      { code: "OAX", name: "Oaxaca" },
      { code: "PUE", name: "Puebla" },
      { code: "QUE", name: "Querétaro" },
      { code: "ROO", name: "Quintana Roo" },
      { code: "SLP", name: "San Luis Potosí" },
      { code: "SIN", name: "Sinaloa" },
      { code: "SON", name: "Sonora" },
      { code: "TAB", name: "Tabasco" },
      { code: "TAM", name: "Tamaulipas" },
      { code: "TLA", name: "Tlaxcala" },
      { code: "VER", name: "Veracruz" },
      { code: "YUC", name: "Yucatán" },
      { code: "ZAC", name: "Zacatecas" }
    ]
  }
};

export const DEFAULT_COUNTRY = "US";

export const COUNTRY_OPTIONS = Object.values(COUNTRIES).map(country => ({
  value: country.code,
  label: country.name
}));

export const getCountryConfig = (countryCode = DEFAULT_COUNTRY) => {
  return COUNTRIES[countryCode] || COUNTRIES[DEFAULT_COUNTRY];
};

export const validatePostalCode = (postalCode, countryCode = DEFAULT_COUNTRY) => {
  const country = getCountryConfig(countryCode);
  const regex = new RegExp(`^${country.postalCodePattern}$`);
  return regex.test(postalCode);
};

export const formatPostalCode = (postalCode, countryCode = DEFAULT_COUNTRY) => {
  if (!postalCode) return "";
  
  const cleaned = postalCode.replace(/[^A-Z0-9]/gi, "").toUpperCase();
  
  if (countryCode === "CA" && cleaned.length === 6) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  }
  
  if (countryCode === "GB") {
    const parts = cleaned.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)(\d[A-Z]{2})$/);
    if (parts) {
      return `${parts[1]} ${parts[2]}`;
    }
  }
  
  return postalCode;
};

export const getPhoneFormatter = (countryCode = DEFAULT_COUNTRY) => {
  const country = getCountryConfig(countryCode);
  return country.phoneFormat;
};